import TextInput from '../../Common/TextInput.js'
import {formSelector, updateForm, useSelector} from '../../../../store.js'

export default function Nickname({formName}) {
  const form = useSelector((state) => formSelector(state, {formName}))
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <li className="form-list-item bigger">
      <TextInput
        label="Account Nickname"
        name="shipper_nickname"
        value={form.name}
        onChange={(event) =>
          updateForm(formName, {
            name: event.target.value,
            hasChanged_name: true,
          })
        }
        errorMessage={errors.name}
        required
      />
    </li>
  )
}
